





<template>
  <div>
    <vs-loading :loading="loading"></vs-loading>

    <vs-card class="paginat">
      <div class="tw-flex tw-justify-between">
        <vs-select
            class=""
            label="Sayfada Gösterilecek Kayıt Sayısı"
            v-model="pageSize"
            @change="handlePageSizeChange"
        >
          <vs-select-item
              v-for="size in pageSizes"
              :key="size"
              :value="size"
              :text="size"
          />
        </vs-select>

        <vs-paginator
            v-if="meta"
            :meta="meta"
            @change="handlePageChange"
        ></vs-paginator>
      
      </div>
    </vs-card>

   
       <vs-card id="gizle">
        {{this.list.length}}
     
       </vs-card>
      
       </vs-card>
       <vs-card>
     <vs-button class="editbutons2"  @click="topPage()" :to="{name: 'SocialContribution'}" type="line"><h6>Sosyal Sorumluluk</h6></vs-button>
        <vs-button class="editbutons2"  @click="topPage()" :to="{name: 'SocialRoles'}" type="line"><h6>Roller</h6></vs-button>
        <vs-button class="editbutons2"  @click="topPage()" :to="{name: 'SocialEvents'}" type="line"><h6>Faaliyetler</h6></vs-button> 
        <vs-button class="editbutons2" color="#E6272D"  type="line"><h6>Görev Alma</h6></vs-button> </vs-card>
    <vs-divider ></vs-divider>
    <div class="text-center"><h3>Kategori Dağılımı</h3></div>
   <br>
    <vs-card class="totalCountCard">

               
                <div class="text-center"><h4>(Görev Alma)Toplam Etkinlik Sayısı: {{totalCount}}</h4></div>
              
            </vs-card>
    <vs-row>
         
        <vs-col vs-lg="3" vs-xs="12">
        
            <vs-card>

                <h4 class="mb-1">%{{percentEgitim}}</h4>
                <h5>Eğitim Alanı</h5>
                <vs-progress :percent="percentEgitim" :total="10" color="primary">primary</vs-progress>
            </vs-card>
        </vs-col>
       
        <vs-col vs-lg="3" vs-xs="12">
            <vs-card>
                <h4 class="mb-1">%{{percentArastir}}</h4>
                <h5>Araştırma</h5>
                <vs-progress :percent="percentArastir" color="success">primary</vs-progress>
            </vs-card>
        </vs-col>
        <vs-col vs-lg="3" vs-xs="12">
            <vs-card>
                <h4 class="mb-1">%{{percentSanat}}</h4>
                <h5>Sanatsal Katkı</h5>
                <vs-progress :percent="percentSanat" color="warning">primary</vs-progress>
            </vs-card>
        </vs-col>
          <vs-col vs-lg="3" vs-xs="12">
            <vs-card>
                <h4 class="mb-1">%{{percentToplum}}</h4>
                <h5>Toplumsal Katkı</h5>
                <vs-progress :percent="percentToplum" color="warning">primary</vs-progress>
            </vs-card>
        </vs-col>
    </vs-row>    
    <br>
     <vs-card >
      

      <div class="tw-flex tw-flex-wrap">
        <div class="tw-w-full tw-flex tw-justify-between tw-items-center">
          <div class="tw-flex">
            <vs-input
                icon="mdi-magnify"
                placeholder="Arama"
                v-model="search"
  v-on:keyup.enter="page = 1; get();"
            />

         
          </div>

        </div>

        <div class="tw-w-full">
          <vs-divider></vs-divider>
        </div>

        <div class="tw-w-full lg:tw-w-1/1">
          <div v-if="loading">Loading...</div>

          <vs-table stripe :data="list">
            <template slot="header">
              <h3>Etkinlik Bilgileri</h3>
            </template>
            <template slot="thead">
              <vs-th>Etkinlik Kayıt No.</vs-th>
               <vs-th>Tarih</vs-th>
                <vs-th>Saat</vs-th>
                 <vs-th>Yer</vs-th>
                <vs-th>Etkinlik Türü</vs-th>
               <vs-th>Etkinlik Adı</vs-th>
               <!--<vs-th>Sürdürülebilir Kalkınma Amaçları</vs-th>
                <vs-th>Kategori</vs-th> -->
                
               

            </template>
            <template slot-scope="{data}">
              <vs-tr  v-for="(item, i) in data" :key="i" >
                 <vs-td :data="item.id">
                  <div class="fontt2" @click="show(item, i)">{{ item.appealId }}</div>
                </vs-td>
                 <vs-td :data="item.startDate">
                  <div class="fontt2" @click="show(item, i)">{{ datefunc(item.startDate) }}</div>
                </vs-td>
                 <vs-td :data="item.startTime">
                  <div class="fontt" @click="show(item, i)">{{ item.startTime }}</div>
                </vs-td>
                  <vs-td :data="item.room">
                  <div class="fontt" @click="show(item, i)">{{ item.room }}</div>
                </vs-td>
                 <vs-td :data="item.eventType">
                  <div class="fontt" @click="show(item, i)">{{ item.eventType }}</div>
                </vs-td>
                
                   <vs-td :data="item.eventName">
                  <div class="fontt" @click="show(item, i)">{{ item.eventName }}</div>
                </vs-td>
                  <!--<vs-td :data="item.relations">
                  <div class="fontt" @click="show(item, i)">{{ item.relations }}</div>
                </vs-td>
                 <vs-td :data="item">
                  
                  <div class="fontt" @click="show(item, i)">{{ socialPrint(item) }}</div>
                </vs-td>-->
                
                   
                
              </vs-tr>
            </template>
          </vs-table>

          <!--<vs-button type="gradient" color="danger" @click="removeAll">Tümünü Sil</vs-button>-->
        </div>

        <div class="tw-w-full lg:tw-w-1/2 lg:tw-pl-5">
          <!--<vs-card v-if="selected">
         
            <div class="header1" >
              <h3>{{ selected.eventName }}</h3>
            </div>
            <div class="close-button" slot="header">
              <vs-row vs-justify="flex-end">
                <vs-button close type="gradient" color="danger" icon-pack="mdi" icon="mdi-favorite" @click="func">X &nbsp</vs-button>
              </vs-row>
            </div>
            
            <div>
            
              <div>
                <strong>Durum: </strong> {{ obj.columns.published ? "Kaydedildi" : "Kaydedilmedi" }}
              </div>
            </div>
            <div slot="footer">
              <vs-row vs-justify="flex-end">
                <vs-button type="gradient" color="warning" icon-pack="mdi" icon="mdi-favorite" :to="{name: 'FolderPage', params: {id: selected.eventName,parametre: this.gonderilecek}}">Görüntüle</vs-button>
              </vs-row>
            </div>
          </vs-card>

          <div v-else>
            <br />
            <vs-alert active="true" color="info">
              Dosya görüntülemek için seçim yapınız.
            </vs-alert>
          </div>-->
        </div>











      </div>

    </vs-card>
  </div>
</template>

<script>
  import { paginatorMixin } from "@/mixins/paginatorMixin";
  import Appeal from "@/libs/appeals/Appeal";
  import Inst from "@/libs/insts/Inst";
  import Ev from "@/libs/evs/Ev";
  import Folder from "@/libs/folders/Folder";
  import SalesSummary from "@/components/dashboard/SalesSummary";
  import SalesIncome from "@/components/dashboard/SalesIncome";
  import TopProducts from "@/components/dashboard/TopProducts";
  import States from "@/components/dashboard/States";
  import Etkinlikler from "@/components/dashboard/Etkinlikler";
    import Blogs from "@/components/dashboard/Blogs";
    import ApexCharts from 'apexcharts'


  export default {
    name: "SocialContribution",
    title: "Toplumsal Katkı Ekranı",
    components: {
      SalesSummary,
      SalesIncome,
      TopProducts,
      States,
      Etkinlikler,
      Blogs
    },
    mixins: [
      paginatorMixin,
    ],

    data() {
      return {
        lock:true,
        totalCount:0,

        egitimCount:0,
        arastirmaCount:0,
        toplumsalCount:0,
        sanatsalCount:0,

        percentEgitim:0,
        percentArastir:0,
        percentToplum:0,
        percentSanat:0,


        paginat:false,
        obj: new Appeal(),
        obj22: new Appeal(),
         obj2: new Folder(),
         countAll:0,
         countAllArray:[],
         countAllArrayFilter:[],
         
        gonderilecek:[],
        
       
        search: "",
        loading: false,
      };
    },

    computed: {
       appealsEt() {
        return this.obj22.appeals
      },
      appeals() {
        return this.obj.appeals
      },
      insts() {
        return this.obj5.insts
      },
      folders() {
        return this.obj2.folders
      },
     

      selected() {
        return this.obj.selected
      },

      saved() {
        return this.obj.saved
      },

      deleted() {
        return this.obj.deleted
      },

      list() { 
       
         if(this.lock && this.appealsEt && this.appealsEt.data){
           
            this.countAllArray=this.appealsEt.data
            for (let i = 0; i < this.countAllArray.length; i++) {
                if(this.countAllArray[i].eventType!=null){
                    if( (this.countAllArray[i].eventType.includes("Eğitim Alanı") || this.countAllArray[i].eventType.includes("Araştırma") || this.countAllArray[i].eventType.includes("Toplumsal Katkı") || this.countAllArray[i].eventType.includes("Sanatsal Katkı")  ) && this.countAllArray[i].published != "Silindi")
                      this.countAllArrayFilter.push(this.countAllArray[i]);                    
                    
                      
                }
                
              
            }
            this.totalCount=this.countAllArrayFilter.length;
             for (let i = 0; i < this.countAllArrayFilter.length; i++) {
                if(this.countAllArray[i].eventType!=null){
                    if(this.countAllArrayFilter[i].eventType.includes("Eğitim Alanı"))
                      this.egitimCount++
                    
                     if(this.countAllArrayFilter[i].eventType.includes("Araştırma"))
                          this.arastirmaCount++
                     
                    if(this.countAllArrayFilter[i].eventType.includes("Toplumsal Katkı"))
                            this.toplumsalCount++

                     if(this.countAllArrayFilter[i].eventType.includes("Sanatsal Katkı"))
                            this.sanatsalCount++        
                      
                }
                
              
            }
            
           this.lock=false
           this.percentage()
        }
        if(this.appeals && this.appeals.data){
         
           return this.countAllArrayFilter

        }
         
        return []
      },
      listFolder() { 
        if(this.folders && this.folders.data){
          this.gonderilecek=this.folders.data
          
          return this.folders.data
        }
        return []
      },
       
      

      meta() {
        if(this.appeals && this.appeals.meta){
          
           console.log(this.appeals.meta)
           return this.appeals.meta
        }
          

        return null
      },
      meta2() {
        if(this.folders && this.folders.meta)
          return this.folders.meta

        return null
      },
      

      submitted() {
        return this.obj.form.submitted
      },

      contaminated() {
        return this.obj.form.errorDetected
      }
    },

    watch: {
      contaminated(val) {
        this.loading = false
      },

      submitted(val) {
        if(val)
          this.loading = false
      },

      saved(val) {
        if(val)
          this.get()
      },

      deleted(val) {
        if(val)
          this.get()
      },
    },

    methods: {
      datefunc(temp){
        var date = ""+temp
        if(temp){
            if(date.length>2){
            var newerdate=date.substring(0,10)
            var newdate = newerdate.split("-").reverse().join("-");
            
            return newdate
        }else{
          return ""
        }
        }else{
          return "-"
        }
        
       },
      idTempCal(item){
          let count=0;
           for (let i = 0; i <  this.appeals.data.length; i++) { 
            
            
            
              if(this.appeals.data[i].id == item.id){
                
               return this.$idTemp+i
              }
              
            }
      },
      etkinlikGoster(item,i){
          
          if(item.published =="Silindi"){         
            return false;
          }
          return true;
      },
      socialPrint(item){
        if(item.socials!=null){
             if(item.socials.indexOf(":")!= -1)
          return item.socials.substring(0,item.socials.indexOf(":"))
        }
       
        return item.socials
      },
      topPage(){
          document.body.scrollTop = 0; // For Safari
          document.documentElement.scrollTop = 0;
      },
      percentage() {
        this.percentEgitim=(100 * this.egitimCount) / this.totalCount;
        this.percentArastir=(100 * this.arastirmaCount) / this.totalCount;
        this.percentSanat=(100 * this.sanatsalCount) / this.totalCount;
        this.percentToplum=(100 * this.toplumsalCount) / this.totalCount;

        this.percentEgitim=this.percentEgitim.toFixed(0);
        this.percentArastir=this.percentArastir.toFixed(0);
        this.percentSanat=this.percentSanat.toFixed(0);
        this.percentToplum=this.percentToplum.toFixed(0);

    
       
      }, 
      goruntule(item){
                  this.$router.push({name: 'FolderPage', params: {id: item.eventName,parametre: this.gonderilecek}})

      },
      get() {
        const params = this.getRequestParams(
          this.search,
          this.page,
          2000
        );

        this.loading = true
        this.obj.getAll(params)
      },
      getEtkinlik() {
       
        const params = this.getRequestParams(
          this.search,
          this.page,
          2000
        );

        this.loading = false
        this.obj22.getAll(params)
      },
      getFolder() {
        const params = this.getRequestParams(
          this.search,
          this.page,
          2000
        );

        this.loading = true
        this.obj2.getAll(params)
      },
      


      handlePageChange(page) {
        this.page = page;
        this.get();
        this.getFolder();
       this.getEtkinlik();
        let e=this.listFolder
     
      },

      handlePageSizeChange() {
        this.page = 1;
         this.get();
         this.getEtkinlik();
        this.getFolder();
       
        let f=this.meta2
        
      },

      refreshList() {
        this.get();
         this.getEtkinlik();
        this.getFolder();
      
        let f=this.meta2
        this.obj.selected = null;
      },

      show(item, index) {
        this.obj.selected = item;
      },

      removeAll() {
        //this.loading = true
        this.obj.deleteAll()
      },
      func(){
        this.obj.selected = null;
      }
    },
    
    mounted() {
        this.get();
        this.getEtkinlik();

      
    }
  };
</script>

<style>

.editbutons2{
margin-left: 13%;
     margin-top: 2%;
   border-style: solid;
  border-width: 2px;
  border-radius: 15px;
},

.paginat{
  display: none;
}
  .vs-component.vs-button.vs-button-danger.vs-button-gradient{
    color:white;
  }
  .vs-component.vs-button.vs-button-primary.vs-button-filled{
    color:white;
  }
  .vs-component.vs-button.vs-button-null.vs-button-filled{
    color:white;
  }

  .header1 {display:inline-block;margin-right:10px;} 
.close1 {text-align: center;}
#gizle{
  display:none
}
.totalCountCard{
  margin-left:35%;
  width:30%;
}
.paginat{
  display: none;
}


</style>